module.exports = __webpack_public_path__ + "static/img/product1.34f3cbf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yiBrand/new/product1.png
// module id = mnSm
// module chunks = 0